export const MOVES = {
  scheduled: { label: "Scheduled", cls: "bg-[#0F1D3D]/5 text-[#0F1D3D] border-[#0F1D3D]/25" },
  departed: { label: "In the air", cls: "bg-[#C6A55C] text-[#0F1D3D] border-[#C6A55C]" },
  diverted: { label: "Diverted", cls: "bg-rose-50 text-rose-700 border-rose-300" },
  landed: { label: "Landed", cls: "bg-emerald-50 text-emerald-700 border-emerald-300" },
  delayed: { label: "Delayed", cls: "bg-amber-50 text-amber-800 border-amber-300" },
  in_position: { label: "In position", cls: "bg-sky-50 text-sky-800 border-sky-300" },
  cancelled: { label: "Cancelled", cls: "bg-zinc-100 text-zinc-500 border-zinc-300 line-through" },
};

export const code = (a) => (a || "").split(" · ")[0].trim();
export const inAir = (lg) => lg.status === "departed" || lg.status === "diverted";
export const shownStatus = (lg) => (lg.in_position && ["scheduled", "delayed"].includes(lg.status) ? "in_position" : lg.status);
export const lateText = (m) => { const d = Math.floor(m / 1440), h = Math.floor((m % 1440) / 60), mm = m % 60; return d ? `${d}d ${h}h` : h ? `${h}h ${mm}m` : `${mm} min`; };
export const nextLeg = (t) => t.legs.find(inAir) || t.legs.find((lg) => ["scheduled", "delayed"].includes(lg.status)) || t.legs[t.legs.length - 1];
export const today = () => new Date().toLocaleDateString("en-CA");
export const nowLocal = () => { const d = new Date(); d.setMinutes(d.getMinutes() - d.getTimezoneOffset()); return d.toISOString().slice(0, 16); };
export const nowIn = (tz) => {
  if (!tz) return nowLocal();
  const parts = new Intl.DateTimeFormat("en-CA", { timeZone: tz, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hourCycle: "h23" }).formatToParts(new Date());
  const p = Object.fromEntries(parts.map((x) => [x.type, x.value]));
  return `${p.year}-${p.month}-${p.day}T${p.hour}:${p.minute}`;
};
export const fmtTime = (s) => {
  if (!s) return "";
  const [h, m] = s.slice(-5).split(":").map(Number);
  if (Number.isNaN(h)) return s;
  return `${((h + 11) % 12) + 1}:${String(m).padStart(2, "0")} ${h < 12 ? "AM" : "PM"}`;
};
export const zoned = (s, zone) => (s ? `${fmtTime(s)}${zone ? ` ${zone}` : ""}` : "");

export function groupOf(t) {
  if (t.status === "completed") return "completed";
  if (t.legs.some(inAir)) return "air";
  return nextLeg(t)?.date === today() ? "today" : "upcoming";
}

export const GROUPS = [["air", "In the air"], ["today", "Today"], ["upcoming", "Upcoming"]];

export function MoveBadge({ status, testId, dark = false }) {
  const m = MOVES[status] || MOVES.scheduled;
  const cls = dark && status === "scheduled" ? "bg-white/10 text-white border-white/40" : m.cls;
  return <span className={`inline-flex items-center px-2.5 py-1 border text-[0.6rem] tracking-[0.2em] uppercase font-semibold ${cls}`} data-testid={testId}>{m.label}</span>;
}
